import React from "react";
import { useParams, Link } from "react-router-dom";
import { Tabs, Tab, Box, useMediaQuery, useTheme } from "@mui/material";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import TableChartIcon from "@mui/icons-material/TableChart";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RuleIcon from "@mui/icons-material/Rule";
import SensorsIcon from "@mui/icons-material/Sensors";

interface ConfigTabInfo {
  value: string;
  label: string;
  icon: React.ReactNode;
}

export const ConfigurationTabs: React.FC = () => {
  const { configType, ckey } = useParams<{
    configType: string;
    ckey: string;
  }>();
  const { translate } = useFlightTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const configTabs: ConfigTabInfo[] = [
    {
      value: "skuTable",
      label: translate("SKUs"),
      icon: <TableChartIcon fontSize="small" />,
    },
    {
      value: "shiftSchedules",
      label: translate("Shift Schedules"),
      icon: <ScheduleIcon fontSize="small" />,
    },
    {
      value: "users",
      label: translate("Users"),
      icon: <PeopleIcon fontSize="small" />,
    },
    {
      value: "alertRules",
      label: translate("Alert Rules"),
      icon: <NotificationsIcon fontSize="small" />,
    },
    {
      value: "adlRules",
      label: translate("ADL Rules"),
      icon: <RuleIcon fontSize="small" />,
    },
    {
      value: "sense",
      label: translate("Sense Configs"),
      icon: <SensorsIcon fontSize="small" />,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
      }}
    >
      <Tabs
        value={configType || "skuTable"}
        variant={isMobile ? "scrollable" : "standard"}
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTab-root": {
            minHeight: "48px",
            textTransform: "none",
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            minWidth: { xs: "120px", sm: "160px" },
          },
        }}
      >
        {configTabs.map(tab => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            icon={tab.icon as any}
            iconPosition="start"
            component={Link}
            to={`/${ckey}/config/${tab.value}`}
            className={`config-tab-${tab.value}`}
            sx={{
              "&.Mui-selected": {
                color: "primary.main",
                fontWeight: "bold",
              },
              "&:not(.Mui-selected)": {
                color: "text.secondary",
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
